import(/* webpackMode: "eager" */ "/codebuild/output/src2742558834/src/app/home/page.tsx");
